/* eslint-disable @typescript-eslint/no-unused-expressions */
import { useLitterFormState } from '@application/state';
import { useRouter } from '@application/utils';
import { MtLittersPage } from '@presentation/pages';
import type { FC } from 'react';
import { useState } from 'react';
import { useFormatLitters } from './api/useFormatLitters';
import { useGetLitters } from './api/useGetLitters';

export const MtLittersPageController: FC = () => {
  // See MtLitterPageController for useage
  const { setLitterFormState } = useLitterFormState();

  const { navigateToRoute } = useRouter();
  const [showArchived, setShowArchived] = useState(false);

  const { litters, littersLoading } = useGetLitters(showArchived);

  const { formatLitter } = useFormatLitters();

  return (
    <>
      <MtLittersPage
        loading={littersLoading}
        onAddClick={() => {
          navigateToRoute('mtLitters', { params: ['new'] });
          setLitterFormState({ values: undefined, litterId: undefined });
        }}
        items={(litters ?? []).map((litter) => ({
          ...formatLitter(litter),
          onClick: () => {
            const id = litter?.id;
            if (!id) return;
            setLitterFormState({ values: undefined, litterId: undefined });
            navigateToRoute('mtLitters', { params: [id.toString()] });
          },
        }))}
        showArchived={showArchived}
        onToggleShowArchived={setShowArchived}
      />
    </>
  );
};
